import React from 'react';
import Switch from 'react-ios-switch';

function InspectorControlSwitch(props) {
    return <Switch className="control-switch" checked={props.value} onChange={props.onChange} />
}

export { InspectorControlSwitch }